import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { db } from "../database";
import { getEnvs } from "../env";

function useIndexedDb(check: boolean) {
	const history = useHistory();
	const [receivedData, setReceivedData] = useState(false);

	const setServerUrl = async () => {
		try {
			let serverUrl;
			const envvars: any = await getEnvs();
			serverUrl = envvars.REACT_APP_SERVER_URL_API;
			return serverUrl;
		} catch (err) {
			console.log(err);
		}
	};

	const getBlockCount = async () => {
		const blockCount = await db.blocks.count();
		return blockCount;
	};
	const getUserSiteCount = async () => {
		await setServerUrl();
		const userSiteCount = await db.userSites.count();
		return userSiteCount;
	};

	const getUserSites = async (lastModified: number) => {
		try {
			const SERVER_URL = await setServerUrl();
			const response = await fetch(`${SERVER_URL}/getUserSites`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ lastModified: lastModified }),
			});
			const res = await response.json();
			if (response.status === 401) {
				history.push("/");
				return;
			}

			if (!res.error) db.userSites.bulkPut(res);
			return res;
		} catch (err) {
			history.push("/");
		}
	};

	const getBlocks = async (lastModified: number) => {
		try {
			const SERVER_URL = await setServerUrl();
			const response = await fetch(`${SERVER_URL}/getBlocks`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ lastModified: lastModified }),
			});
			const res = await response.json();
			if (response.status === 401) {
				history.push("/");
			}
			if (!res.error) db.blocks.bulkPut(res);
			return res;
		} catch (err) {
			history.push("/");
		}
	};

	const getIndex = async (lastModified: number) => {
		//await setServerUrl();
		try {
			const SERVER_URL = await setServerUrl();
			const response = await fetch(`${SERVER_URL}/getUserIndex`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ lastModified: lastModified }),
			});
			try {
				if (response.status === 401) {
					history.push("/");
				}
				if (response.ok) {
					const res = await response.json();
					await db.other.put({ id: 0, userSearchIndex: res });
				}
			} catch (err) {
				// history.push("/");
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		const checkForNewData = async () => {
			//get index files and site counts
			const userSiteCount = await getUserSiteCount();
			const blockCount = await getBlockCount();
			//get user sites and index file
			if (userSiteCount > 0) {
				const latest = await db.userSites.orderBy("lastModified").last();
				if (latest) {
					await getUserSites(latest.lastModified);
				} else {
					await getUserSites(0);
				}
			} else {
				await getUserSites(0);
				await getIndex(0);
			}

			//get blocks
			if (blockCount && blockCount > 0) {
				const latest = await db.blocks.orderBy("lastModified").last();
				if (latest) {
					await getBlocks(latest.lastModified);
				} else {
					await getBlocks(0);
				}
			} else {
				await getBlocks(0);
			}
			setReceivedData(true);
		};
		if (check === true) {
			checkForNewData();
		}
	}, [check]);
	return receivedData;
}

export default useIndexedDb;
